<template>
    <v-card flat outlined class="side-item" v-bind="{ color }" @click="activate">
        <v-card-title class="side-item__title">
            <span> {{ title }} </span>
            <template v-if="content">
                <v-spacer />
                <v-badge inline light color="grey lighten-5" class="side-item__badge" v-bind="{ content }" />
            </template>
        </v-card-title>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
import { EMPLOYMENT_FIELD_SIDES, EMPLOYMENT_FIELD_TYPES } from "@/assets/variables";

export default {
    props: {
        side: { type: String, default: EMPLOYMENT_FIELD_SIDES.DOCUMENT.value },
        type: { type: String, default: EMPLOYMENT_FIELD_TYPES.TEXT.value },
        items: { type: Array, default: () => [] },
    },
    computed: {
        ...mapState("employment/form/tool", {
            color(state) {
                if (!(state.side == this.side && state.type == this.type)) return;

                let { color } = EMPLOYMENT_FIELD_SIDES[this.side] || {};
                return `${color} white--text`;
            },
        }),
        title() {
            return EMPLOYMENT_FIELD_TYPES[this.type]?.text;
        },
        content() {
            return this.items.filter((item) => item.side == this.side && item.type == this.type)?.length || 0;
        },
    },
    methods: {
        activate() {
            let { side, type } = this;
            this.$store.commit("employment/form/tool/init", { side, type });
        },
    },
};
</script>

<style lang="scss" scoped>
.side-item {
    &::before {
        display: none;
    }

    &__title {
        font-size: 1.4rem !important;
        font-weight: bold !important;
    }

    &__badge {
        ::v-deep .v-badge__wrapper {
            top: 0;
            left: 0;
        }
        ::v-deep span {
            color: #131313 !important;
        }
    }
}
</style>
